(function () {
  // Open cart drawer after PDP/quick-add when cart type is drawer
  document.addEventListener('theme:product:add', function (event) {
    if (!window.theme || !window.theme.settings || window.theme.settings.cartType !== 'drawer') return;
    var button = event.detail && event.detail.button;
    if (!button || button.closest('cart-drawer') || button.closest('[data-quick-add-modal]')) return;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && !drawer.classList.contains('is-open')) {
      drawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show', { bubbles: true }));
    }
  });
})();

// FreeGift / mystery-gift auto-sync DISABLED — product handle missing (404) and
// the fetch monkey-patch was racing cart qty/ADD updates and leaving the drawer stuck.
